export default __webpack_public_path__ + "static/media/gallery-header-1440.dce12fe4.png";